export default "__VITE_ASSET__DyYwhscw__"